import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    product: String,
    funnelSlug: String
  }

  requestOffer(event) {
    const button = event.currentTarget
    const spinner = button.querySelector('.spinner')
    const content = button.querySelector('.flex')

    // If it's pflegebox, redirect after tracking
    if (this.productValue === "pflegebox") {
      window.location.href = "/pflegebox/order_selection"
      return
    }

    // Disable button and show spinner
    button.disabled = true
    content.classList.add('invisible')
    spinner.classList.remove('hidden')

    // Send AJAX request to the server
    fetch(`/lf/${this.funnelSlugValue}/request_cross_sell_offer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ product: this.productValue })
    })
      .then(response => response.json())
      .then(data => {
        // Hide spinner
        spinner.classList.add('hidden')
        content.classList.remove('invisible')

        if (data.success) {
          // Update button to show success state
          button.innerHTML = '<span class="text-green-500 font-semibold text-m md:text-xl">Anfrage erhalten</span>'
          button.classList.remove('hover:scale-105', 'hover:border-ph24_orange')
          button.classList.add('cursor-default')
        } else {
          // Handle error state
          content.innerHTML = '<span class="text-red-500 font-semibold text-m md:text-xl">Fehler. Bitte erneut versuchen.</span>'
          button.disabled = false
        }
      })
      .catch(error => {
        console.error('Error:', error)
        // Hide spinner and show error message
        spinner.classList.add('hidden')
        content.classList.remove('invisible')
        content.innerHTML = '<span class="text-red-500 font-semibold text-m md:text-xl">Fehler. Bitte erneut versuchen.</span>'
        button.disabled = false
      })
  }
}